export default ({ val }) => {
	return {
		type: "number",
		value: parseFloat(val),
		primitive: true,
	};
};